// Write Ebook Page Specific Scripts here
$(document).ready(function(){
    if($('body.ebook-page')) {

    }
});